import axios from 'axios'
import { useAuthStore } from '@/stores/auth'

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
})

apiClient.interceptors.request.use(
  (config) => {
    const authStore = useAuthStore()
    const token = authStore.token

    if (token) {
      config.headers.Authorization = `Token ${token}`
    }
    return config
  },

  (error) => {
    return Promise.reject(error)
  },
)

apiClient.interceptors.response.use(
  (response) => {
    return response
  },
  async (error) => {
    const authStore = useAuthStore()

    if (error.response?.status === 401) {
      if (authStore.refreshToken) {
        try {
          await authStore.refreshAccessToken()
          const originalRequest = error.config
          originalRequest.headers.Authorization = `Token ${authStore.token}`
          return apiClient(originalRequest)
        } catch (refreshError) {
          authStore.logout()
          window.location.href = '/login'
        }
      } else {
        authStore.logout()
        // window.location.href = '/login'
      }
    }

    if(error.response?.status === 403){
    }

    return Promise.reject(error)
  },
)

export default apiClient
